/* Tutos : filtres par tag (bascule client, URL partageable, View
   Transitions API, fallback bascule sèche) + morph de la tuile cliquée
   vers la couverture de l'article (view-transition-name tuto-hero).
   Les apparitions au scroll sont gérées par motion.js comme partout. */
(function () {
  var grille = document.querySelector('[data-grille]');
  if (!grille) return;
  var cartes = Array.prototype.slice.call(grille.querySelectorAll('.tt-card'));
  var pills = Array.prototype.slice.call(document.querySelectorAll('.tt-pill'));
  var compte = document.querySelector('[data-compte]');
  var compteLabel = document.querySelector('[data-compte-label]');
  var motTuto = compteLabel ? compteLabel.getAttribute('data-singulier') : 'tuto';
  var motTutos = compteLabel ? compteLabel.getAttribute('data-pluriel') : 'tutos';
  var verrou = false;

  /* un nom de transition unique par carte, posé seulement le temps du
     filtrage : les cartes qui restent glissent vers leur nouvelle
     position, les autres fondent. Hors filtrage les cartes restent
     anonymes pour ne pas parasiter la transition de page (tuto-hero). */
  function nommer(actif) {
    cartes.forEach(function (c, i) { c.style.viewTransitionName = actif ? 'tt-c' + i : ''; });
  }

  function appliquer(tag) {
    var n = 0;
    cartes.forEach(function (c) {
      /* la tuile YouTube (data-fixe) suit son tag comme les autres,
         mais ne compte pas comme un tuto dans le compteur */
      var visible = tag === 'tous' || c.getAttribute('data-tag') === tag;
      c.hidden = !visible;
      if (visible && !c.hasAttribute('data-fixe')) n++;
    });
    if (compte) compte.textContent = n;
    if (compteLabel) compteLabel.textContent = (n > 1 ? motTutos : motTuto) + (tag === 'tous' ? '' : ' · ' + libelle(tag));
  }
  function libelle(tag) {
    var p = pills.filter(function (x) { return x.getAttribute('data-tag') === tag; })[0];
    return p ? p.textContent.trim() : '';
  }
  function activer(pill) {
    pills.forEach(function (p) {
      var on = p === pill;
      p.classList.toggle('on', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function surClic(pill) {
    if (verrou || pill.classList.contains('on')) return;
    var tag = pill.getAttribute('data-tag');
    activer(pill);
    var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (document.startViewTransition && !reduit) {
      verrou = true;
      nommer(true);
      var t = document.startViewTransition(function () { appliquer(tag); });
      t.finished.finally(function () { verrou = false; nommer(false); });
    } else {
      appliquer(tag);
    }
    var url = tag === 'tous' ? location.pathname : location.pathname + '?tag=' + encodeURIComponent(tag);
    history.replaceState(null, '', url);
  }
  pills.forEach(function (p) { p.addEventListener('click', function () { surClic(p); }); });

  /* morph vers l'article : le nom tuto-hero est posé sur la photo de la
     tuile cliquée juste avant la navigation, et reposé sur cette même
     tuile quand on revient, pour que le morph joue dans les deux sens */
  function nomHero(article) {
    grille.querySelectorAll('[data-article] .tt-ph').forEach(function (p) { p.style.viewTransitionName = ''; });
    if (!article) return;
    var ph = grille.querySelector('[data-article="' + article + '"] .tt-ph');
    if (ph) ph.style.viewTransitionName = 'tuto-hero';
  }
  grille.addEventListener('click', function (e) {
    var carte = e.target.closest('[data-article]');
    if (!carte) return;
    var article = carte.getAttribute('data-article');
    nomHero(article);
    try { sessionStorage.setItem('tt-vt-article', article); } catch (err) {}
  });
  try { nomHero(sessionStorage.getItem('tt-vt-article')); } catch (err) {}

  /* deep-link : ?tag=… applique le filtre à l'arrivée */
  var initial = new URLSearchParams(location.search).get('tag');
  if (initial) {
    var p = pills.filter(function (x) { return x.getAttribute('data-tag') === initial; })[0];
    if (p) { activer(p); appliquer(initial); }
  }
})();
